import { Component, ElementRef, HostListener, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { User } from 'src/app/model/user';

import * as UserFilesActions from 'src/app/store/user-file/user-file.actions';
import * as SiteActions from 'src/app/store/site/site.actions';
import { Site } from 'src/app/model/site';
import { Observable, Subscription, filter } from 'rxjs';
import { ALLOWED_IMAGE_TYPES, MAX_UPLOAD_SIZE } from 'src/app/conf/user-files';
import { TIMEZONES } from 'src/app/conf/timezones';
import { selectAddEditSuccess } from 'src/app/store/site/site.selector';
import { TranslateService } from '@ngx-translate/core';
import { Notification, NotificationLevel } from 'src/app/model/notification';
import * as NotificationsActions from 'src/app/store/notifications/notifications.actions';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { selectSiteImages } from 'src/app/store/user-file/user-file.selector';
import { UserFile } from 'src/app/model/user-file';
import { UserFileService } from 'src/app/services/user-file.service';
import { StandardDynamicComponent, StandardNewValidator, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
	templateUrl: './site.dialog.component.html',
	styles: `
		#map {
			width: 80vw;
			height: 390px;
		}
		#previewImage {
			max-height: 80px;
			border-radius: 10px;
		}
		img {
			-webkit-user-drag: none;
			user-drag: none;
		}
	`
})
export class SiteDialogComponent implements OnInit, OnDestroy {

	addEditSuccess$: Observable<boolean | undefined>;
	addEditSuccessSub: Subscription | undefined;

	// Google Maps API
	apiLoaded: Observable<boolean>;

	map: google.maps.Map;
	zoom: number;
	posMap: google.maps.LatLng;
	positionMarker: google.maps.LatLng;
	latitude: number;
	longitude: number;
	address: string;
	mapTypeId: any;

	siteMarker: any;
	place: any;
	filteredPlace: any[];

	siteForm: FormGroup;
	site: Site;

	siteImages$: Observable<UserFile[] | undefined>;
	siteImagesSub: Subscription | undefined;

	technician: User;

	autoInsert = false;

	filteredTimezone: any[];

	// file picker
	fileToUpload: File;
	image: string | ArrayBuffer;
	imageId = '';

	siteImage = { src: 'assets/images/tablet-bg.jpg' };
	imgPreview: SafeUrl = '';
	canDeleteUpload: boolean;

	maxUploadSize = MAX_UPLOAD_SIZE;
	@ViewChild('imageInput', { static: false }) imageInput: ElementRef;

	timezones = TIMEZONES;

	searchControl: FormGroup;

	// design
	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private domSanitizer: DomSanitizer,
		private userFileService: UserFileService,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
		private translate: TranslateService,
		private ngZone: NgZone
	) {
		if (config.data !== undefined && config.data.site !== undefined) {
			this.site = Object.assign({}, config.data.site);
		} else {
			this.site = new Site();
		}
		this.initSelectors();
	}

	ngOnInit(): void {
		this.imgPreview = this.domSanitizer.bypassSecurityTrustUrl('data:image/jpeg;base64, /9j/4AAQSkZJRgABAQEBLAEsAAD/4QVeRXhpZgAASUkqAAgAAAAIAA4BAgASAAAAbgAAABIBAwABAAAAAQAAABoBBQABAAAAgAAAABsBBQABAAAAiAAAACgBAwABAAAAAgAAADEBAgANAAAAkAAAADIBAgAUAAAAngAAAGmHBAABAAAAsgAAAOoAAABDcmVhdGVkIHdpdGggR0lNUAAsAQAAAQAAACwBAAABAAAAR0lNUCAyLjEwLjI4AAAyMDIyOjAyOjIzIDEwOjI4OjU5AAIAhpIHABkAAADQAAAAAaADAAEAAAABAAAAAAAAAAAAAAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVAACQD+AAQAAQAAAAEAAAAAAQQAAQAAAAABAAABAQQAAQAAAFUAAAACAQMAAwAAAFwBAAADAQMAAQAAAAYAAAAGAQMAAQAAAAYAAAAVAQMAAQAAAAMAAAABAgQAAQAAAGIBAAACAgQAAQAAAPMDAAAAAAAACAAIAAgA/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCABVAQADASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD3+iiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAP//ZAP/hDTdodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDQuNC4wLUV4aXYyIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0RXZ0PSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VFdmVudCMiIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6R0lNUD0iaHR0cDovL3d3dy5naW1wLm9yZy94bXAvIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9ImdpbXA6ZG9jaWQ6Z2ltcDo2NWZmYTJkNy03NzNmLTQ3OTUtOGIxNS05MDQ0ZDY3OWU4ZGYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Yjc3NGMxN2MtYmQyOC00MThiLWIxZmEtNDQ0ZTU0N2ZjYzAyIiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6M2JjYjUwNTUtZTJjYy00OTRjLWEyNjQtYzZmNGFhZTdkYzliIiBkYzpGb3JtYXQ9ImltYWdlL2pwZWciIEdJTVA6QVBJPSIyLjAiIEdJTVA6UGxhdGZvcm09IkxpbnV4IiBHSU1QOlRpbWVTdGFtcD0iMTY0NTYwODU0MDc4NTE2NCIgR0lNUDpWZXJzaW9uPSIyLjEwLjI4IiB4bXA6Q3JlYXRvclRvb2w9IkdJTVAgMi4xMCI+IDx4bXBNTTpIaXN0b3J5PiA8cmRmOkJhZz4gPHJkZjpsaSBzdEV2dDphY3Rpb249InNhdmVkIiBzdEV2dDpjaGFuZ2VkPSIvIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjYxNDgxMTdlLWQ1NDktNDFmZS04NDAyLTMzNmE2Mzc1MTc0MCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iR2ltcCAyLjEwIChMaW51eCkiIHN0RXZ0OndoZW49IjIwMjItMDItMjNUMTA6MjU6NTIrMDE6MDAiLz4gPHJkZjpsaSBzdEV2dDphY3Rpb249InNhdmVkIiBzdEV2dDpjaGFuZ2VkPSIvIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjAzMjgxOGFlLWNjNjctNGNiNS05NTEyLTNiZjI5NGJiMDZkOCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iR2ltcCAyLjEwIChMaW51eCkiIHN0RXZ0OndoZW49IjIwMjItMDItMjNUMTA6Mjk6MDArMDE6MDAiLz4gPC9yZGY6QmFnPiA8L3htcE1NOkhpc3Rvcnk+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDw/eHBhY2tldCBlbmQ9InciPz7/4gKwSUNDX1BST0ZJTEUAAQEAAAKgbGNtcwQwAABtbnRyUkdCIFhZWiAH5gACABcACQAcAAphY3NwQVBQTAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA9tYAAQAAAADTLWxjbXMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1kZXNjAAABIAAAAEBjcHJ0AAABYAAAADZ3dHB0AAABmAAAABRjaGFkAAABrAAAACxyWFlaAAAB2AAAABRiWFlaAAAB7AAAABRnWFlaAAACAAAAABRyVFJDAAACFAAAACBnVFJDAAACFAAAACBiVFJDAAACFAAAACBjaHJtAAACNAAAACRkbW5kAAACWAAAACRkbWRkAAACfAAAACRtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACQAAAAcAEcASQBNAFAAIABiAHUAaQBsAHQALQBpAG4AIABzAFIARwBCbWx1YwAAAAAAAAABAAAADGVuVVMAAAAaAAAAHABQAHUAYgBsAGkAYwAgAEQAbwBtAGEAaQBuAABYWVogAAAAAAAA9tYAAQAAAADTLXNmMzIAAAAAAAEMQgAABd7///MlAAAHkwAA/ZD///uh///9ogAAA9wAAMBuWFlaIAAAAAAAAG+gAAA49QAAA5BYWVogAAAAAAAAJJ8AAA+EAAC2xFhZWiAAAAAAAABilwAAt4cAABjZcGFyYQAAAAAAAwAAAAJmZgAA8qcAAA1ZAAAT0AAACltjaHJtAAAAAAADAAAAAKPXAABUfAAATM0AAJmaAAAmZwAAD1xtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAEcASQBNAFBtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEL/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT//gAUQ3JlYXRlZCB3aXRoIEdJTVAA/8IAEQgAHgBaAwERAAIRAQMRAf/EABUAAQEAAAAAAAAAAAAAAAAAAAAI/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABqkAAAAAAAAAAAAAAAAAAAAAAAH//xAAUEAEAAAAAAAAAAAAAAAAAAABQ/9oACAEBAAEFAkP/xAAUEQEAAAAAAAAAAAAAAAAAAABQ/9oACAEDAQE/AUP/xAAUEQEAAAAAAAAAAAAAAAAAAABQ/9oACAECAQE/AUP/xAAUEAEAAAAAAAAAAAAAAAAAAABQ/9oACAEBAAY/AkP/xAAUEAEAAAAAAAAAAAAAAAAAAABQ/9oACAEBAAE/IUP/2gAMAwEAAgADAAAAEJJJJJJJJJJJJJJJJJJJJJJJJP/EABQRAQAAAAAAAAAAAAAAAAAAAFD/2gAIAQMBAT8QQ//EABQRAQAAAAAAAAAAAAAAAAAAAFD/2gAIAQIBAT8QQ//EABQQAQAAAAAAAAAAAAAAAAAAAFD/2gAIAQEAAT8QQ//Z');

		this.subscribeAll();

		this.searchControl = new FormGroup({
			location: new FormControl('', [Validators.required])
		});

		if ((this.site.Address) && (this.site.Address !== '')) {
			this.address = this.site.Address;
			this.latitude = this.site.Latitude;
			this.longitude = this.site.Longitude;
			this.positionMarker = new google.maps.LatLng({
				lat: this.latitude,
				lng: this.longitude
			});
			this.posMap = this.positionMarker;
			this.zoom = 13;
			this.mapTypeId = 'roadmap';
		} else {
			this.address = '';
			this.latitude = 0;
			this.longitude = 0;
			this.positionMarker = new google.maps.LatLng({
				lat: this.latitude,
				lng: this.longitude
			});
			this.posMap = new google.maps.LatLng({
				lat: 43.0,
				lng: -24.0
			});
			this.zoom = 3;
			this.mapTypeId = 'roadmap';
		}

		this.initMap();

		if (this.site.Timezone === '' || this.site.Timezone === undefined || this.site.Timezone === null) {
			this.site.Timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (this.site.Name !== '' && this.site.Name !== undefined && this.site.Name !== null) {
				this.autoInsert = true;
			}
		}

		this.store.dispatch(UserFilesActions.getUserFileTypes());
		this.buildForm();
		this.onResize();

		StandardNewValidator.setFirstCompile(true);
	}

	async initMap(): Promise<void> {
		const { Map, InfoWindow, MapTypeRegistry } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
		const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
		const { PinElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

		// Map setting
		this.map = new Map(document.getElementById("map") as HTMLElement, {
			center: this.posMap,
			zoom: this.zoom,
			mapId: '001',
			mapTypeId: this.mapTypeId
		} as google.maps.MapOptions
		);

		// init Marker settings
		const defaultCameMarkerImg = document.createElement('img');
		defaultCameMarkerImg.src = '/assets/images/map/map_marker.png';
		defaultCameMarkerImg.width = 45;
		defaultCameMarkerImg.height = 60;

		const defaultCameMarker = new PinElement({
			glyph: defaultCameMarkerImg,
			scale: 1.0
		});

		this.siteMarker = new AdvancedMarkerElement({
			map: this.map,
			position: this.positionMarker,
			content: defaultCameMarker.element,
			title: this.site.Name,
			gmpClickable: true,
			gmpDraggable: true,
		});

		const infoWindow = new InfoWindow();

		this.siteMarker.addListener('click', ({ domEvent }) => {
			const { target } = domEvent;
			infoWindow.close();
			if ((this.site.Name !== '') && (this.site.Name !== undefined)) {
				infoWindow.setContent(`
				<div class="text-lg font-medium">
					${this.site.Name} | ${this.site.Description}
				</div>
				<div class="flex flex-row align-items-center gap-2 mt-2">
						<i class="pi cm-marker"></i>
						<div class="text-normal">${this.address}</div>
				</div>
				`);
				/* if ((this.address !== '') && (this.address !== undefined)) {
					infoWindow.setContent(`
					<div class="flex flex-row align-items-center gap-2 mt-2">
						<i class="pi cm-marker"></i>
						<div class="text-normal">${this.address}</div>
					</div>
					`);
				} */
			} else {
				infoWindow.setContent(`
				<div class="text-lg font-medium">
					${this.translate.instant('NEW_SITE')}
				</div>
				<div class="flex flex-row align-items-center gap-2 mt-2">
						<i class="pi cm-marker"></i>
						<div class="text-normal">${this.address}</div>
				</div>
				`);
				/* if ((this.address !== '') && (this.address !== undefined)) {
					infoWindow = infoWindow + infoWindow.setContent(`
					<div class="flex flex-row align-items-center gap-2 mt-2">
						<i class="pi cm-marker"></i>
						<div class="text-normal">${this.address}</div>
					</div>
					`);
				} */
			}
			infoWindow.open(this.siteMarker.map, this.siteMarker);
		});

		this.siteMarker.addListener('dragstart', () => {
			infoWindow.close();
		});

		this.siteMarker.addListener('dragend', (event) => {
			this.markerDragEnd(event);
		});

		this.map.addListener("maptypeid_changed", (event) => {
			this.mapTypeId = this.map.getMapTypeId();
		});
	}

	buildForm(): void {
		this.siteForm = new FormGroup({
			'name': new FormControl(this.site.Name, Validators.required),
			'description': new FormControl(this.site.Description, Validators.required),
			'timezone': new FormControl(this.site.Timezone, Validators.required),
			'location': new FormControl(this.site.Address),
		});
	}

	initSelectors(): void {
		this.addEditSuccess$ = this.store.select(selectAddEditSuccess);
		this.siteImages$ = this.store.select(selectSiteImages);
	}

	subscribeAll(): void {
		this.addEditSuccessSub = this.addEditSuccess$?.subscribe(
			(addEditSuccess) => {
				if (addEditSuccess) {
					this.ref.close('success');
				}
			}
		);
		this.siteImagesSub = this.siteImages$.subscribe((userFiles) => {
			const userFile = userFiles.find(f => f.SiteId === this.site.Id);
			if (!userFile) {
				return;
			}
			this.siteImagesSub = this.userFileService.getUserFileContent(userFile.Id)
				.pipe(filter(resp => !!resp))
				.subscribe(resp => {
					this.siteImage = { src: resp };
					this.imgPreview = this.siteImage.src;
				});
		});
	}

	getPlaceholder(): string {
		return this.address != '' ? this.address : this.translate.instant('SEARCH_ADDRESS');
	}

	imageSource(): { src: string } {
		return this.siteImage;
	}

	ngOnDestroy(): void {
		this.addEditSuccessSub?.unsubscribe();
		this.siteImagesSub?.unsubscribe();
	}

	clearLogo(): void {
		this.canDeleteUpload = false;
		this.imageId = '';
		this.fileToUpload = null;
		this.imgPreview = '';
		// this.store.dispatch(PermissionActions.getPermissionTemplateLogoSuccess({fileContent: null}));
	}

	handleFileInput(event) {
		if (event.currentFiles.length > 0) {
			this.fileToUpload = event.currentFiles[0];

			if (!ALLOWED_IMAGE_TYPES.includes(this.fileToUpload.type)) {
				const notification = new Notification("FILE_NOT_COMPATIBLE", this.translate.instant("MAX_UPLOAD_SIZE") + " 900KB", NotificationLevel.Error, '');
				this.store.dispatch(NotificationsActions.addNotification({ notification: notification, toastOnly: true }));

				this.fileToUpload = null;
				this.imgPreview = '';
				this.canDeleteUpload = true;
			} else if (this.fileToUpload.size > MAX_UPLOAD_SIZE) {
				const notification = new Notification("FILE_TOO_BIG", this.translate.instant("MAX_UPLOAD_SIZE") + " 900KB", NotificationLevel.Error, '');
				this.store.dispatch(NotificationsActions.addNotification({ notification: notification, toastOnly: true }));

				this.fileToUpload = null;
				this.imgPreview = '';
				this.canDeleteUpload = true;
			} else {
				const myReader: FileReader = new FileReader();
				myReader.onloadend = () => {
					this.image = myReader.result;
					this.imgPreview = this.image;
				};
				myReader.readAsDataURL(this.fileToUpload);

				const notification = new Notification("SUCCESS", this.translate.instant("IMAGE_UPLOADED_SUCCESS"), NotificationLevel.Success, '');
				this.store.dispatch(NotificationsActions.addNotification({ notification: notification, toastOnly: true }));

				this.canDeleteUpload = true;
			}
		} else {
			const notification = new Notification("ERROR", "Upload image error", NotificationLevel.Error, '');
			this.store.dispatch(NotificationsActions.addNotification({ notification: notification, toastOnly: true }));
		}
	}

	updateMode(): boolean {
		return !!this.site.Id;
	}

	filterTimezone(event) {
		const filtered: any[] = [];
		const query = event.query;
		if (this.timezones) {
			for (let i = 0; i < this.timezones.length; i++) {
				const timezone = this.timezones[i];
				if (timezone.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
					filtered.push(timezone);
				}
			}
		}
		this.filteredTimezone = filtered;
	}

	markerDragEnd($event): void {
		this.latitude = $event.latLng.lat();
		this.longitude = $event.latLng.lng();
		const latlng = new google.maps.LatLng(this.latitude, this.longitude);

		const geocoder = new google.maps.Geocoder();
		const request = { location: latlng };

		geocoder.geocode(request, (results, status) => {
			this.ngZone.run(() => {
				this.address = results[0].formatted_address;
				this.posMap = results[0].geometry.location;
				this.positionMarker = results[0].geometry.location;
				this.zoom = 13;
			});
		});
	}

	async completeMethod(event: { query: any; }): Promise<void> {
		const { AutocompleteService } = await google.maps.importLibrary("places") as google.maps.PlacesLibrary;
		const autocompleteService = new AutocompleteService();

		autocompleteService.getPlacePredictions({ input: event.query }, (predictions, status) => {
			if (status === google.maps.places.PlacesServiceStatus.OK) {
				this.filteredPlace = predictions;
			}
		});
	}

	onSelectMap(event: any) {
		const geocoder = new google.maps.Geocoder();
		geocoder
			.geocode({ placeId: event.value.place_id })
			.then(({ results }) => {
				if (results[0]) {
					this.address = results[0].formatted_address;
					this.latitude = results[0].geometry.location.lat();
					this.longitude = results[0].geometry.location.lng();
					this.positionMarker = results[0].geometry.location;
					this.posMap = this.positionMarker;
					this.zoom = 13;
					this.initMap();
				} else {
					window.alert("No results found");
				}
			})
			.catch((e) => window.alert("Geocoder failed due to: " + e));
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.siteForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.siteForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void {
		const site: Site = {
			...this.site,
			Name: this.f.name.value,
			Description: this.f.description.value,
			Address: this.address,
			Latitude: this.latitude,
			Longitude: this.longitude,
			Timezone: this.f.timezone.value,
		};
		if (this.updateMode()) {
			this.store.dispatch(SiteActions.updateSite({ site, background: { metadata: this.fileToUpload, content: this.image } }));
		} else {
			this.store.dispatch(SiteActions.addSite({ site, background: { metadata: this.fileToUpload, content: this.image } }));
		}
	}

	get f(): any {
		return this.siteForm.controls;
	}

	closeDialog(): void {
		this.ref.close();
	}

	get fMaps(): any {
		return this.searchControl.controls;
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile() {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	col12Responsive(): string {
		return StandardPageLayout.col6Responsive(this.screenWidth);
	}

	dynamicAutocomplete(): string {
		return StandardDynamicComponent.dynamicAutocomplete(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextDesktopTabletWidth(this.screenWidth, 'w-23rem', 'w-25rem');
	}

	dynamicLongInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextDesktopTabletWidth(this.screenWidth, 'w-49rem', 'w-25rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	showErrorRequiredMessage(type: SiteDialogComponent["f"]): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	showErrorConfirmInvalidMessage(type: SiteDialogComponent["f"], notEquivalentType: string): boolean {
		return StandardNewValidator.showErrorConfirmInvalidMessage(type, notEquivalentType, this.siteForm);
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	newShowErrors(type: SiteDialogComponent["f"], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}
}
